module.exports = __webpack_public_path__ + "static/media/ines_dionisio.009ee10b.jpg";